import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Vehicle, Model, Address, Order, Client, Sender, Recipient, SpecialSelect, Document, CityZip} from '../../../models/models';
import {Translation} from '../../../models/translation';
import {ModelService} from '../../../services/model.service';
import {AddressService} from '../../../services/address.service';
import {PortalOrderService} from '../../../services/portal-order.service';
import {LoginService} from '../../../services/login.service';
import {AmagVehicleDataService} from '../../../services/amag-vehicle-data.service';
import {CheckService} from '../../../services/check.service';
import {UserService} from '../../../services/user.service';
import {MatLegacyCheckboxChange as MatCheckboxChange} from '@angular/material/legacy-checkbox';
import {MatLegacyOption as MatOption, MatLegacyOptionSelectionChange as MatOptionSelectionChange} from '@angular/material/legacy-core';
import {MatDatepicker} from '@angular/material/datepicker';
import {MatLegacyRadioButton as MatRadioButton} from '@angular/material/legacy-radio';
import {MatStepper} from '@angular/material/stepper';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {UntypedFormControl} from '@angular/forms';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {DatePipe} from '@angular/common';
import Swal from 'sweetalert2';

class Notifications {
  value: string;
}

export const CustomFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'DD.MM.YYYY',
    monthYearA11yLabel: 'DD.MM.YYYY',
  },
};

@Component({
  selector: 'app-transport-task',
  styleUrls: ['./transport-task.component.css'],
  templateUrl: './transport-task.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MAT_DATE_FORMATS, useValue: CustomFormats
    },
    [DatePipe]
  ],
})

export class TransportTaskComponent implements OnInit {
  @ViewChild('stepper', {static: true}) stepper: MatStepper;
  @ViewChild('elementToFocusSender') inputSender: ElementRef;
  @ViewChild('elementToFocusRecipient') inputRecipient: ElementRef;
  @ViewChild('clientRadio') clientRadio: MatRadioButton;
  @ViewChild('SpecialSelectOptions') SpecialSelectOptions: MatOption[];
  @ViewChild('fileDropRef') fileDropEl: ElementRef;

  public order: Order;
  public translation: Translation;

  // Sender variables
  public senderList: Address[];
  public autoCompleteSender = new UntypedFormControl();
  public filteredSenderList: Observable<Address[]>;
  public disabledSenderFields1: string;
  public disabledSenderFields2: string;
  public senderDropDownIsVisible = false;
  public tempSenderDate: Date = new Date();
  public senderIsFreeData = true;
  public senderSearchList: CityZip[];
  public autoCompleteSenderSearch = new UntypedFormControl();
  public filteredSenderSearchList: Observable<CityZip[]>;
  public senderFloatLabelControl = new UntypedFormControl('auto');
  public senderSearchText = '';

  // Recipient variables
  public recipientList: Address[];
  public autoCompleteRecipient = new UntypedFormControl();
  public filteredRecipientList: Observable<Address[]>;
  public disabledRecipientFields1: string;
  public disabledRecipientFields2: string;
  public recipientDropDownIsVisible = false;
  public tempRecipientDate: Date = new Date();
  public recipientIsFreeData = true;
  public recipientSearchList: CityZip[];
  public autoCompleteRecipientSearch = new UntypedFormControl();
  public filteredRecipientSearchList: Observable<CityZip[]>;
  public recipientFloatLabelControl = new UntypedFormControl('auto');
  public recipientSearchText = '';

  // Vehicle- & Model variables
  public modelList: Model[];
  public tabs: string[];
  public selectedVehicle = new UntypedFormControl(0);
  public autoCompleteModelList: UntypedFormControl[];
  public filteredModelList: Observable<Model[]>;
  public disabledVehicleFields: string;

  // Other variables
  public selectedAid;
  public partnerList = sessionStorage.getItem('Addresses').split(',');
  public notifications = new Notifications()[4];
  public times: Notifications[] = [{value: '08:00 - 10:00'}, { value: '10:00 - 12:00'}, { value: '13:00 - 15:00'}, { value: '15:00 - 17:00'}];
  public isAmagUser = false;
  public minDate = new Date();

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private modelService: ModelService,
    private amagVehicleDataService: AmagVehicleDataService,
    private addressService: AddressService,
    private orderService: PortalOrderService,
    private userService: UserService,
    private datepipe: DatePipe,
    private router: Router
    ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(4);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.isAmagUser = JSON.parse(sessionStorage.getItem('PrimaryAddress')).GroupDesc === 'AMAG';
    this.selectedAid = JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid;
    this.stepper._getIndicatorType = () => 'number';
    // Remove empty items fix
    this.partnerList = this.partnerList.filter(item => item);
    this.enableFields();
    this.initData();
  }

  enableFields() {
    this.disabledSenderFields1 = 'false';
    this.disabledSenderFields2 = 'false';
    this.disabledRecipientFields1 = 'false';
    this.disabledRecipientFields2 = 'false';
    this.disabledVehicleFields = 'true';
  }

  toggleAmagFields() {
    if (this.disabledVehicleFields === 'false') {
      this.disabledVehicleFields = 'true';
    } else {
      this.order.VehicleList[this.selectedVehicle.value].CommissionNumber = '';
      this.order.VehicleList[this.selectedVehicle.value].ChassisNumber = '';
      this.order.VehicleList[this.selectedVehicle.value].Color = '';
      this.order.VehicleList[this.selectedVehicle.value].ModelName = '';
      this.disabledVehicleFields = 'false';
    }
  }

  initData() {
    if (sessionStorage.getItem('PrimaryAddress') === '' || sessionStorage.getItem('PrimaryAddress') === 'null') {
      this.router.navigate(['/home'], { queryParams: { message: 2 } });
    }
    // General Infos
    this.order = new Order();
    this.order.UserId = +sessionStorage.getItem('UserId');
    this.order.User = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.order.Phone = sessionStorage.getItem('Phone');
    this.order.Email = sessionStorage.getItem('Email');
    this.order.DeliveryOption = 0;
    this.order.DeliveryOptionText = '';
    this.order.FreightPayerSelection = 0;
    this.order.FreightPayerAid = this.selectedAid;
    this.order.Language = localStorage.getItem('Language');
    this.order.ConfirmationMail = sessionStorage.getItem('ConfirmationMail') === 'true';
    // Client
    this.order.Client = new Client();
    this.order.Client.PartnerId = JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerId;
    this.order.Client.PartnerFid = JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerFid;
    this.order.Client.PartnerAid = JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid;
    this.order.Client.Name = JSON.parse(sessionStorage.getItem('PrimaryAddress')).Description;
    this.order.Client.Contact = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.order.Client.Email = sessionStorage.getItem('Email');
    this.order.Client.Phone = sessionStorage.getItem('Phone');
    this.order.Client.AddressLine1 = JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryStreet;
    this.order.Client.AddressLine2 = JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryAddition;
    this.order.Client.Zip = +JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryZip;
    this.order.Client.City = JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryCity;
    this.order.Client.Region = JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryRegion;
    // General Sender and Recipient Info
    this.notifications = [
      {value: this.translation.None},
      {value: this.translation.FifteenMinutesBeforeNotification},
      {value: this.translation.ThirtyMinutesBeforeNotification},
      {value: this.translation.OneHourBeforeNotification}];
    // Sender
    this.order.Sender = new Sender();
    this.order.Sender.Selection = 0;
    this.order.Sender.Notification = this.translation.None;
    this.order.Sender.PickUpTimeText = this.times[0].value;
    // Recipient
    this.order.Recipient = new Recipient();
    this.order.Recipient.Selection = 0;
    this.order.Recipient.Notification = this.translation.None;
    this.order.Recipient.DeliveryTimeText = this.times[0].value;
    // Vehicles
    this.autoCompleteModelList = [];
    this.autoCompleteModelList.push(new UntypedFormControl());
    this.order.VehicleList = [];
    this.order.VehicleList.push(new Vehicle());
    this.order.VehicleList[this.selectedVehicle.value].SpecialSelects = [
      {Value: this.translation.None, Key: 0, Disabled: false, Selected: false},
      {Value: this.translation.HighRoof, Key: 1, Disabled: false, Selected: false},
      {Value: this.translation.RotatingLightHighRoofRack, Key: 2, Disabled: false, Selected: false},
      {Value: this.translation.SnowPlow, Key: 3, Disabled: false, Selected: false},
      {Value: this.translation.Lowered, Key: 4, Disabled: false, Selected: false},
      {Value: this.translation.VehicleNotRunning, Key: 5, Disabled: false, Selected: false},
      {Value: this.translation.NeedsBooster, Key: 6, Disabled: false, Selected: false},
      {Value: this.translation.OthersPleaseDescribe, Key: 7, Disabled: false, Selected: false}];
    this.tabs = [this.translation.Vehicle + ' 1'];
    this.order.VehicleList[this.selectedVehicle.value].Files = [];
    // Data
    this.addressService.getAddressesByCompanies(sessionStorage.getItem('Companies')).subscribe(responseAddress => {
      if (responseAddress.Ok) {
        this.senderList = responseAddress.Obj;
        this.recipientList = responseAddress.Obj;
        this.filterSenderDropDown();
        this.filterRecipientDropDown();

        this.addressService.getCityZipList().subscribe(responseCityZip => {
          if (responseCityZip.Ok) {
            this.senderSearchList = responseCityZip.Obj;
            this.recipientSearchList = responseCityZip.Obj;
            this.filterSenderSearchDropDown();
            this.filterRecipientSearchDropDown();

            this.modelService.getModels().subscribe(responseModels => {
              if (responseModels.Ok) {
                this.modelList = responseModels.Obj;
              } else if (responseModels.Msg === 'Internal Server Error') { console.log(responseModels.Ex); this.modelList = []; }
              else { this.modelList = []; }
              if (responseModels.Msg) { this.toast.fire({title: responseModels.Msg, icon: responseModels.Ok ? 'success' : 'error'}); }
              this.filterModelDropDown();
            }, error => { this.toast.fire(this.translation.InternalServerError); });
          } else if (responseCityZip.Msg === 'Internal Server Error') { console.log(responseCityZip.Ex); }
          if (responseCityZip.Msg) { this.toast.fire({title: responseCityZip.Msg, icon: responseCityZip.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
      } else if (responseAddress.Msg === 'Internal Server Error') { console.log(responseAddress.Ex); }
      if (responseAddress.Msg) { this.toast.fire({title: responseAddress.Msg, icon: responseAddress.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  /* Sender */

  senderChangeToFreeData() {
    this.clearSenderData();
    this.senderDropDownIsVisible = false;
    this.senderIsFreeData = true;
    this.order.Sender.Selection = 1;
    if (this.order.FreightPayerSelection === 1) {
      this.order.FreightPayerSelection = 0;
      this.clientRadio.checked = true;
    }
    this.disabledSenderFields1 = 'false';
    this.disabledSenderFields2 = 'false';
  }
  senderChangeToSelfData() {
    this.clearSenderData();
    this.senderDropDownIsVisible = false;
    this.senderIsFreeData = false;
    this.order.Sender.Selection = 0;
    this.disabledSenderFields1 = 'true';
    this.disabledSenderFields2 = 'true';

    this.order.Sender.PartnerId = this.order.Client.PartnerId;
    this.order.Sender.PartnerFid = this.order.Client.PartnerFid;
    this.order.Sender.PartnerAid = this.order.Client.PartnerAid;
    this.order.Sender.Name = this.order.Client.Name;
    this.order.Sender.Contact = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.order.Sender.Email = sessionStorage.getItem('Email');
    this.order.Sender.Phone = sessionStorage.getItem('Phone');
    this.order.Sender.AddressLine1 = this.order.Client.AddressLine1;
    this.order.Sender.AddressLine2 = this.order.Client.AddressLine2;
    this.order.Sender.Zip = this.order.Client.Zip;
    this.order.Sender.City = this.order.Client.City;
    this.order.Sender.Region = this.order.Client.Region;
  }
  senderChangeToCoreData() {
    this.clearSenderData();
    this.senderDropDownIsVisible = true;
    this.senderIsFreeData = false;
    this.order.Sender.Selection = 0;
    this.disabledSenderFields1 = 'true';
    this.disabledSenderFields2 = 'false';
    this.addressService.getAddressesByCompanies(sessionStorage.getItem('Companies')).subscribe(response => {
      if (response.Ok) {
        this.senderList = response.Obj;
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      this.filterSenderDropDown();
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  filterSenderDropDown() {
    this.filteredSenderList = this.autoCompleteSender.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSenders(value))
    );
  }
  _filterSenders(value: string): Address[] {
    let filterValue = value;
    if (!Number(value) && value !== null) { filterValue = value.toLowerCase(); }
    return this.senderList.filter(sender =>
      sender.Description.toLowerCase().includes(filterValue) ||
      sender.DeliveryAddition.toLowerCase().includes(filterValue) ||
      sender.DeliveryStreet.toLowerCase().includes(filterValue) ||
      sender.DeliveryCity.toLowerCase().includes(filterValue) ||
      sender.DeliveryZip.includes(filterValue) ||
      sender.PartnerFid.includes(filterValue));
  }
  onSenderSelectChange(value: any) {
    if (value != null) {
      if (value !== '') {
        this.addressService.getAddressByPartnerAid(value).subscribe(response => {
          if (response.Ok) {
            this.order.Sender.PartnerId = response.Obj.PartnerId;
            this.order.Sender.PartnerFid = response.Obj.PartnerFid;
            this.order.Sender.PartnerAid = response.Obj.PartnerAid;
            this.order.Sender.Name = response.Obj.Description;
            this.order.Sender.Contact = '';
            this.order.Sender.Email = '';
            this.order.Sender.Phone = '';
            this.order.Sender.AddressLine1 = response.Obj.DeliveryStreet;
            this.order.Sender.AddressLine2 = response.Obj.DeliveryAddition;
            this.order.Sender.Zip = +response.Obj.DeliveryZip;
            this.order.Sender.City = response.Obj.DeliveryCity;
            this.order.Sender.Region = response.Obj.DeliveryRegion;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
      }
    }
  }

  filterSenderSearchDropDown() {
    this.filteredSenderSearchList = this.autoCompleteSenderSearch.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSenderSearch(value))
    );
  }
  _filterSenderSearch(value: string): CityZip[] {
    let filterValue = value;
    if (!Number(value) && value !== null && value !== undefined) { filterValue = value.toLowerCase(); }
    return this.senderSearchList.filter(senderSearchItem =>
      senderSearchItem.City.toLowerCase().startsWith(filterValue) ||
      senderSearchItem.Zip.toLowerCase().startsWith(filterValue));
  }
  onSenderSearch(event: MatOptionSelectionChange, senderCityZip: CityZip) {
    if (event.isUserInput) {
      this.order.Sender.Zip = +senderCityZip.Zip;
      this.order.Sender.City = senderCityZip.City;
      this.order.Sender.PartnerFid = senderCityZip.ForeignId;
      this.filterSenderSearchDropDown();
    }
  }

  clearSenderData() {
    this.autoCompleteSender.reset();
    this.order.Sender.PartnerId = 0;
    this.order.Sender.PartnerFid = '';
    this.order.Sender.PartnerAid = '';
    this.order.Sender.Name = '';
    this.order.Sender.Contact = '';
    this.order.Sender.Email = '';
    this.order.Sender.Phone = '';
    this.order.Sender.AddressLine1 = '';
    this.order.Sender.AddressLine2 = '';
    this.order.Sender.Zip = null;
    this.order.Sender.City = '';
    this.order.Sender.Region = '';
  }

  openSenderDatePicker(picker: MatDatepicker<Date>) {
    picker.open();
    setTimeout(() => this.inputSender.nativeElement.focus());
  }

  /* Recipient */

  recipientChangeToFreeData() {
    this.clearRecipientData();
    this.recipientDropDownIsVisible = false;
    this.recipientIsFreeData = true;
    this.order.Recipient.Selection = 1;
    if (this.order.FreightPayerSelection === 2) {
      this.order.FreightPayerSelection = 0;
      this.clientRadio.checked = true;
    }
    this.disabledRecipientFields1 = 'false';
    this.disabledRecipientFields2 = 'false';
  }
  recipientChangeToSelfData() {
    this.clearRecipientData();
    this.recipientDropDownIsVisible = false;
    this.recipientIsFreeData = false;
    this.order.Recipient.Selection = 0;
    this.disabledRecipientFields1 = 'true';
    this.disabledRecipientFields2 = 'true';
    this.order.Recipient.PartnerId = this.order.Client.PartnerId;
    this.order.Recipient.PartnerFid = this.order.Client.PartnerFid;
    this.order.Recipient.PartnerAid = this.order.Client.PartnerAid;
    this.order.Recipient.Name = this.order.Client.Name;
    this.order.Recipient.Contact = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.order.Recipient.Email = sessionStorage.getItem('Email');
    this.order.Recipient.Phone = sessionStorage.getItem('Phone');
    this.order.Recipient.AddressLine1 = this.order.Client.AddressLine1;
    this.order.Recipient.AddressLine2 = this.order.Client.AddressLine2;
    this.order.Recipient.Zip = this.order.Client.Zip;
    this.order.Recipient.City = this.order.Client.City;
    this.order.Recipient.Region = this.order.Client.Region;
  }
  recipientChangeToCoreData() {
    this.clearRecipientData();
    this.recipientDropDownIsVisible = true;
    this.recipientIsFreeData = false;
    this.order.Recipient.Selection = 0;
    this.disabledRecipientFields1 = 'true';
    this.disabledRecipientFields2 = 'false';
    this.addressService.getAddressesByCompanies(sessionStorage.getItem('Companies')).subscribe(response => {
      if (response.Ok) {
        this.recipientList = response.Obj;
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      this.filterRecipientDropDown();
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  filterRecipientDropDown() {
    this.filteredRecipientList = this.autoCompleteRecipient.valueChanges.pipe(
      startWith(''),
      map(value => this._filterRecipients(value))
    );
  }
  _filterRecipients(value: string): Address[] {
    let filterValue = value;
    if (!Number(value) && value !== null) { filterValue = value.toLowerCase(); }
    return this.recipientList.filter(recipient =>
      recipient.Description.toLowerCase().includes(filterValue) ||
      recipient.DeliveryStreet.toLowerCase().includes(filterValue) ||
      recipient.DeliveryCity.toLowerCase().includes(filterValue) ||
      recipient.DeliveryZip.includes(filterValue) ||
      recipient.PartnerFid.includes(filterValue));
  }
  onRecipientSelectChange(value: string) {
    if (value != null) {
      this.addressService.getAddressByPartnerAid(value).subscribe( response => {
        if (response.Ok) {
          this.order.Recipient.PartnerId = response.Obj.PartnerId;
          this.order.Recipient.PartnerFid = response.Obj.PartnerFid;
          this.order.Recipient.PartnerAid = response.Obj.PartnerAid;
          this.order.Recipient.Name = response.Obj.Description;
          this.order.Recipient.Contact = '';
          this.order.Recipient.Email = '';
          this.order.Recipient.Phone = '';
          this.order.Recipient.AddressLine1 = response.Obj.DeliveryStreet;
          this.order.Recipient.AddressLine2 = response.Obj.DeliveryAddition;
          this.order.Recipient.Zip = +response.Obj.DeliveryZip;
          this.order.Recipient.City = response.Obj.DeliveryCity;
          this.order.Recipient.Region = response.Obj.DeliveryRegion;
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    }
  }

  filterRecipientSearchDropDown() {
    this.filteredRecipientSearchList = this.autoCompleteRecipientSearch.valueChanges.pipe(
      startWith(''),
      map(value => this._filterRecipientSearch(value))
    );
  }
  _filterRecipientSearch(value: string): CityZip[] {
    let filterValue = value;
    if (!Number(value) && value !== null && value !== undefined) { filterValue = value.toLowerCase(); }
    return this.recipientSearchList.filter(recipientSearchItem =>
      recipientSearchItem.City.toLowerCase().includes(filterValue) ||
      recipientSearchItem.Zip.toLowerCase().includes(filterValue));
  }
  onRecipientSearch(event: MatOptionSelectionChange, recipientCityZip: CityZip) {
    if (event.isUserInput) {
      this.order.Recipient.Zip = +recipientCityZip.Zip;
      this.order.Recipient.City = recipientCityZip.City;
      this.order.Recipient.PartnerFid = recipientCityZip.ForeignId;
      this.filterRecipientSearchDropDown();
    }
  }

  clearRecipientData() {
    this.autoCompleteRecipient.reset();
    this.order.Recipient.PartnerId = 0;
    this.order.Recipient.PartnerFid = '';
    this.order.Recipient.PartnerAid = '';
    this.order.Recipient.Name = '';
    this.order.Recipient.Contact = '';
    this.order.Recipient.Email = '';
    this.order.Recipient.Phone = '';
    this.order.Recipient.AddressLine1 = '';
    this.order.Recipient.AddressLine2 = '';
    this.order.Recipient.Zip = null;
    this.order.Recipient.City = '';
    this.order.Recipient.Region = '';
  }

  /* Vehicle */

  selectModel(model) {
    this.order.VehicleList[this.selectedVehicle.value].ModelName = model.UnitId;
    this.tabs[this.selectedVehicle.value] = this.order.VehicleList[this.selectedVehicle.value].ModelName;
  }

  filterModelDropDown() {
    this.filteredModelList = this.autoCompleteModelList[this.selectedVehicle.value].valueChanges.pipe(
      startWith(''),
      map(value => this._filterVehicles(value))
    );
  }
  _filterVehicles(value: string): Model[] {
    const filterValue = value;
    return this.modelList.filter(model => model.UnitRemark.includes(filterValue));
  }
  getDisplayFn() {
    return (val) => this.display(val);
  }
  display(model): string {
    return model ? model.UnitRemark : model;
  }

  addVehicle() {
    this.tabs.push(this.translation.Vehicle + ' ' + (+this.selectedVehicle.value + 2));
    this.order.VehicleList.push(new Vehicle());
    this.selectedVehicle.setValue(this.tabs.length - 1);
    if (this.selectedVehicle.value < 0) { this.selectedVehicle.setValue(0); }
    this.order.VehicleList[this.selectedVehicle.value].SpecialSelects = [
      {Value: this.translation.None, Key: 0, Disabled: false, Selected: false},
      {Value: this.translation.HighRoof, Key: 1, Disabled: false, Selected: false},
      {Value: this.translation.RotatingLightHighRoofRack, Key: 2, Disabled: false, Selected: false},
      {Value: this.translation.SnowPlow, Key: 3, Disabled: false, Selected: false},
      {Value: this.translation.Lowered, Key: 4, Disabled: false, Selected: false},
      {Value: this.translation.VehicleNotRunning, Key: 5, Disabled: false, Selected: false},
      {Value: this.translation.NeedsBooster, Key: 6, Disabled: false, Selected: false},
      {Value: this.translation.OthersPleaseDescribe, Key: 7, Disabled: false, Selected: false}];
    this.autoCompleteModelList.push(new UntypedFormControl());
    this.filterModelDropDown();
    this.order.VehicleList[this.selectedVehicle.value].Files = [];
  }
  removeVehicle() {
    this.tabs.splice(this.selectedVehicle.value, 1);
    this.order.VehicleList.splice(this.selectedVehicle.value, 1);
    this.selectedVehicle.setValue(this.selectedVehicle.value - 1);
    if (this.selectedVehicle.value < 0) { this.selectedVehicle.setValue(0); }
  }
  getAmagVehicleData() {
    if (this.disabledVehicleFields === 'false') { return; }
    this.amagVehicleDataService.getAmagVehicleDataByCommissionNumber(this.order.VehicleList[this.selectedVehicle.value].CommissionNumber).subscribe(response => {
      if (response.Ok) {
        if (response.Obj == null) { this.toast.fire({title: this.translation.InvalidCommissionNumber, icon: 'warning'}); }
        this.order.VehicleList[this.selectedVehicle.value].ChassisNumber = response.Obj.ChassisNumber;
        this.order.VehicleList[this.selectedVehicle.value].Color = response.Obj.Color;
        this.order.VehicleList[this.selectedVehicle.value].ModelName = response.Obj.ModelText + ' [' + response.Obj.ModelCode + ']';
        this.tabs[this.selectedVehicle.value] = this.order.VehicleList[this.selectedVehicle.value].ModelName;
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }
  specialCheckboxChange(e: MatCheckboxChange, s: SpecialSelect) {
    s.Selected = e.checked;
    if (s.Key === 0) {
      if (e.checked) {
        this.order.VehicleList[this.selectedVehicle.value].SpecialTextActive = false;
        this.order.VehicleList[this.selectedVehicle.value].SpecialSelects.forEach(specialSelect => {
          if (specialSelect.Key !== 0) {
            specialSelect.Disabled = true;
            specialSelect.Selected = false;
          }
        });
      } else {
        this.order.VehicleList[this.selectedVehicle.value].SpecialSelects.forEach(specialSelect => {
          if (specialSelect.Key !== 0) { specialSelect.Disabled = false; }
        });
      }
    }
    if (s.Key === 7) {
      this.order.VehicleList[this.selectedVehicle.value].SpecialTextActive = e.checked;
    }
  }

  /* Confirm */

  changeDeliveryOptions(value: number, text: string) {
    this.order.DeliveryOption = value;
    this.order.DeliveryOptionText = text;
  }
  changeFreightPayer(value: number) {
    this.order.FreightPayerSelection = value;
  }
  send() {
    switch (this.order.FreightPayerSelection) {
      case 0: this.order.FreightPayerAid = this.selectedAid; break;
      case 1: this.order.FreightPayerAid = this.order.Sender.PartnerAid; break;
      case 2: this.order.FreightPayerAid = this.order.Recipient.PartnerAid; break;
      default: this.order.FreightPayerAid = this.selectedAid; break;
    }
    this.orderService.insertOrder(this.order).subscribe(response => {
      if (response.Ok) {
        this.router.navigate(['/home'], { queryParams: { message: 1 } });
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  /* Others */

  validate() {
    switch (this.stepper.selectedIndex) {
      case 0:
        this.order.Sender.PickUpDateText = this.datepipe.transform(this.tempSenderDate, 'dd.MM.yyyy');
        this.orderService.validateSender(this.order).subscribe(response => {
          if (response.Ok) {
            this.order = response.Obj;
            this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
        break;
      case 1:
        this.order.Recipient.DeliveryDateText = this.datepipe.transform(this.tempRecipientDate, 'dd.MM.yyyy');
        this.orderService.validateRecipient(this.order).subscribe(response => {
          if (response.Ok) {
            this.order = response.Obj;
            this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
        break;
      case 2:
        this.orderService.validateVehicles(this.order).subscribe(response => {
          if (response.Ok) {
            this.order = response.Obj;
            this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
        break;
      case 3: this.stepper.selectedIndex += 1;
    }
  }
  back() {
    this.stepper.selectedIndex = this.stepper.selectedIndex - 1;
  }

  toggleConfirmationMail() {
    this.order.ConfirmationMail = !this.order.ConfirmationMail;
    if (sessionStorage.getItem('ConfirmationMailAsked') === 'false' && this.order.ConfirmationMail) {
      Swal.fire({
        title: this.translation.ConfirmationMailTitle,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.translation.Yes,
        denyButtonText: this.translation.NoJustThisTime,
        cancelButtonText: this.translation.Cancel,
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.userService.updateUserConfirmationMail(this.order.UserId, true, false).subscribe(response => {
            if (response.Ok) {
              if (response.Obj) {
                sessionStorage.setItem('ConfirmationMailAsked', 'true');
                Swal.fire({icon: 'success', text: this.translation.ConfirmationMailSettingSuccessfullySaved});
              } else {
                Swal.fire({icon: 'error', text: this.translation.Oops});
              }
            } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
            if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
          }, error => { this.toast.fire(this.translation.InternalServerError); });
        }
        if (result.isDenied) {
          this.userService.updateUserConfirmationMail(this.order.UserId, false, false).subscribe(response => {
            if (response.Ok) {
              if (response.Obj) {
                sessionStorage.setItem('ConfirmationMailAsked', 'true');
                Swal.fire({icon: 'success', text: this.translation.ConfirmationMailSettingSuccessfullySaved});
              } else {
                Swal.fire({icon: 'error', text: this.translation.Oops});
              }
            } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
            if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
          }, error => { this.toast.fire(this.translation.InternalServerError); });
        }
        if (result.isDismissed) {
          this.order.ConfirmationMail = !this.order.ConfirmationMail;
        }
      });
    }
  }
}
